module.exports = __webpack_public_path__ + "img/icon-file-pdf.5aaa2723.svg";